import { render, staticRenderFns } from "./vehiclesMain.vue?vue&type=template&id=13fbec62&scoped=true&"
import script from "./vehiclesMain.vue?vue&type=script&lang=js&"
export * from "./vehiclesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fbec62",
  null
  
)

export default component.exports